module.exports = __webpack_public_path__ + "img/35.6a5d3f27.jpg";